export default __webpack_public_path__ + "static/Placeholder Image-25e26d4c32b8be4cc2c4df0138e97e1c.jpg";